import {Button, App, Modal, Space, Spin} from "antd";
import React, {useEffect, useRef, useState} from "react";
import styles from "../Models/index.module.scss";
import {useQuery, useMutation} from "react-query";
import jwtAxios from "../../../../auth/jwt-api";
import Loading from "../../../../layouts/components/Loading/index";
import {clsx} from "clsx";

import {uz} from "date-fns/locale";
import {format} from "date-fns";
import {MdDelete} from "react-icons/md";
import {DownloadOutlined, ExclamationCircleFilled, HeartOutlined, HeartFilled, EyeOutlined} from "@ant-design/icons";
import {useAuthDatas} from "../../../../auth/JWTAuthProvider";
import translate from "../../../../i18n/translate";
import {pdf} from '@react-pdf/renderer';
import {useReactToPrint} from "react-to-print";
import PaymentModel from "../Models/PaymentModel";
import OrderModelSchema from "./OrderModelSchema";
import OrderLogModal from "../Models/OrderLogModal";
import OfflineContractUpload from "../Models/OfflineContractUpload";
import ApartmentPDFDocument from "../Models/ApartmentPDFDocument";
import {useDispatch, useSelector} from "react-redux";
import {attachUser, clearAttach, updateFavorites} from "../../../../slice/userData";

const {confirm} = Modal;

export default function ApratmentModelSchema({
                                                 searchParams,
                                                 setSearchParams,
                                                 refetchApartments,
                                             }) {
    const { message } = App.useApp();

    const {user} = useAuthDatas();
    const dispatch = useDispatch();
    const {userData} = useSelector(state => state.userData);
    const {rate} = useSelector(state => state.rate);
    const [favoriteLoading, setFavoriteLoading] = useState(false);
    const [orderLogOpen, setOrderLogOpen] = useState(false);
    const [contractLoading, setContractLoading] = useState(false);
    const contentRef = useRef(null)
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [iframeModalOpen, setIframeModalOpen] = useState(false);
    const [photo_from_camera, setPhoto_from_camera] = useState("");
    const [myIdLoading, setMyIdLoading] = useState(false);
    const [isVerifyMode, setIsVerifyMode] = useState(false);
    const {
        data: apartmentRes,
        isLoading,
        refetch: refetchInfo,
    } = useQuery(
        ["apartment", searchParams.floor, searchParams.block, searchParams.apartment_number],
        () =>
            jwtAxios.get("/apartment", {
                params: {
                    floor: searchParams.floor,
                    block: searchParams.block,
                    apartment_number: searchParams.apartment_number,
                },
            }),
        {
            enabled:
                !!searchParams.floor &&
                !!searchParams.block &&
                !!searchParams.apartment_number,
        }
    );

    const { mutate: sendSms, isLoading: smsLoading } = useMutation(
        (data) => jwtAxios.post('/sms', data),
        {
            onSuccess: () => {
                message.success("SMS muvaffaqiyatli yuborildi");
            },
            onError: (error) => {
                message.error(error.response?.data?.error || "SMS yuborishda xatolik yuz berdi");
            }
        }
    );

    const apartment = apartmentRes?.data?.data?.results?.rows[0];
    const order = apartment?.orders?.[0];
    const reactToPrintFn = useReactToPrint({contentRef});

    // MyID identify request when photo_from_camera is available
    useEffect(() => {
        if (photo_from_camera && userData?.pnfl && userData?.birthDate && searchParams.apartmentId) {
            const identifyUser = async () => {
                setMyIdLoading(true);
                try {
                    const response = await jwtAxios.post('/myId/identify', {
                        pinfl: userData.pnfl,
                        birth_date: userData.birthDate,
                        front: photo_from_camera,
                        contractId: order?.contracts?.[0]?.id,
                        checkUser: isVerifyMode
                    });
                    if (response?.data?.data?.status_code===1){
                        refetchInfo()
                        message.success(isVerifyMode ? "Пользователь подтвердил" : "Договор подписан через MyID");
                    }else  {
                        message.warning(response?.data?.data?.status_text)
                    }
                } catch (error) {
                    const details = error?.response?.data?.error?.detail;
                    if (Array.isArray(details)) {
                        details.forEach(err => {
                            const msg = err?.msg || "";
                            if (msg.toLowerCase().includes("pinfl")) {
                                message.error("PINFL — неверно.");
                            } else if (msg.toLowerCase().includes("birth_date")) {
                                message.error("Неверная дата рождения");
                            } else if (msg.toLowerCase().includes("minimum required age is 14")) {
                                message.error("Минимальный возраст — 14 лет.");
                            } else {
                                message.error(msg || "Произошла ошибка при проверке MyID.");
                            }
                            console.error("MyID identify error:", msg);
                        });
                    } else {
                        message.error(error?.response?.data?.error || "Произошла ошибка при проверке MyID.");
                        console.error("MyID identify error:", error);
                    }
                } finally {
                    setMyIdLoading(false);
                }
            };
            identifyUser();
        }
    }, [photo_from_camera, searchParams.apartmentId]);

    const handleGeneratePdf = async () => {
        if (!apartment || !searchParams.apartment_number) return;
        setPdfLoading(true);
        try {
            const blob = await pdf(
                <ApartmentPDFDocument
                    apartment={apartment}
                    order={order}
                    userData={userData}
                    rate={rate}
                    user={user}
                />
            ).toBlob();
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        } catch (error) {
            console.error("PDF generation error:", error);
        } finally {
            setPdfLoading(false);
        }
    };

    // Cleanup PDF URL on unmount or apartment change
    useEffect(() => {
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
                setPdfUrl(null);
            }
        };
    }, [apartment?.id]);

    // Save client to redux when order exists
    React.useEffect(() => {
        if (order?.client) {
            dispatch(attachUser({
                id: order.client.id,
                customerName: order.client.customerName || "",
                customerPhone: order.client.customerPhone || "",
                customerPhone2: order.client.customerPhone2 || "",
                email: order.client.email || "",
                address: order.client.address || "",
                clientType: order.client.clientType || "individual",
                passportGivenPlace: order.client.passportGivenPlace || "",
                passportGivenDate: order.client.passportGivenDate || "",
                series: order.client.series || "",
                pnfl: order.client.pnfl || "",
                birthDate: order.client.birthDate || "",
                director: order.client.director || "",
                bank: order.client.bank || "",
                bank_account: order.client.bank_account || "",
                mfo_code: order.client.mfo_code || "",
                oked_code: order.client.oked_code || "",
                inn: order.client.inn || "",
                favorites: order.client.favorites || []
            }));
        }
    }, [order?.client?.id]);

    const deletePayment = (payment) => {
        confirm({
            title: "Вы действительно хотите отменить платеж?",
            icon: <ExclamationCircleFilled/>,
            content: "После удаления платежа восстановить его невозможно!",
            okText: "Удалить",
            cancelText: "Назад",
            async onOk() {
                try {
                    await jwtAxios.delete(`/payment/${payment.id}`);
                    message.success("Платеж отменен.");
                    refetchInfo();
                } catch (error) {
                    message.error(error.response?.data?.error || translate("payment.delete_error"));
                }
            },
        });
    };
    const deleteOrder = (order) => {
        confirm({
            title: "Вы уверены, что хотите отменить заказ?",
            icon: <ExclamationCircleFilled/>,
            content: "Вы уверены, что хотите отменить заказ?",
            okText: "Удалить",
            cancelText: "Назад",
            async onOk() {
                try {
                    await jwtAxios.delete(`/order/${order.id}`);
                    message.success("Заказ удален");
                    refetchInfo();
                    refetchApartments();
                } catch (error) {
                    message.error(
                        error.response?.data?.error || translate("order.delete_error")
                    );
                }
            },
        });
    };

    const cancelReservation = (order) => {
        confirm({
            title: "Вы уверены, что хотите отменить бронирование?",
            icon: <ExclamationCircleFilled/>,
            content: "После отмены бронирования его невозможно восстановить!",
            okText: "Отменить бронирование",
            cancelText: "Назад",
            async onOk() {
                try {
                    await jwtAxios.post(`/order/${order.id}/cancel`);
                    message.success("Бронирование отменено");
                    refetchInfo();
                    refetchApartments();
                } catch (error) {
                    message.error(
                        error.response?.data?.error || "Ошибка при отмене бронирования"
                    );
                }
            },
        });
    };

    const generateContract = async () => {
        if (!order?.id) return;
        setContractLoading(true);
        try {
            await jwtAxios.post(`/contract/generate`, { orderId: order.id });
            message.success("Shartnoma muvaffaqiyatli yaratildi");
            refetchInfo();
        } catch (error) {
            message.error(error.response?.data?.error || "Произошла ошибка.");
        } finally {
            setContractLoading(false);
        }
    };

    const OnCancelIframe = () => {
        const iframe = document.getElementById("myid_iframe");
        if (iframe?.contentWindow) {
            iframe.contentWindow.postMessage({cmd: 'close'}, '*');
        }
        setIframeModalOpen(false);
    };

    const OpenModalIframe = (verifyMode = false) => {
        setIsVerifyMode(verifyMode);
        setIframeModalOpen(true);
    };

    const handleIframeLoad = () => {
        const iframe = document.getElementById("myid_iframe");
        if (iframe?.contentWindow) {
            iframe.contentWindow.postMessage({cmd: 'open', config: {locale: 'uz', disableSwitch: true, threshold:250}}, '*');
        }
    };

    useEffect(() => {
        const handleMessage = (e) => {
            if (e.data?.cmd === 2 && e?.data?.photo_from_camera) {
                setPhoto_from_camera(e.data.photo_from_camera);
                const iframe = document.getElementById("myid_iframe");
                if (iframe?.contentWindow) {
                    iframe.contentWindow.postMessage({cmd: 'close'}, '*');
                }
                setIframeModalOpen(false);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    const isFavorite = userData?.favorites?.includes(apartment?.id);

    const toggleFavorite = async () => {
        if (!userData?.id || !apartment?.id) return;
        setFavoriteLoading(true);
        try {
            let res;
            if (isFavorite) {
                res = await jwtAxios.delete(`/client/${userData.id}/favorites`, {
                    data: {apartmentId: apartment.id}
                });
            } else {
                res = await jwtAxios.post(`/client/${userData.id}/favorites`, {
                    apartmentId: apartment.id
                });
            }
            dispatch(updateFavorites(res?.data?.data?.client?.favorites || []));
        } catch (error) {
            message.error("Xatolik yuz berdi");
        } finally {
            setFavoriteLoading(false);
        }
    };

    return (
        <>
            {/*{apartment && (*/}
            {/*  <Print*/}
            {/*    apartment={apartment}*/}
            {/*    searchParams={searchParams}*/}
            {/*    setSearchParams={setSearchParams}*/}
            {/*  />*/}
            {/*)}*/}
            <Modal
                open={searchParams.apartment_number}
                onOk={() => setSearchParams({...searchParams, orderModel: "true"})}
                onCancel={() => {
                    setSearchParams({...searchParams, apartment_number: undefined});
                }}
                width={10000}
                loading={myIdLoading}
                // title={apartment?.}
                style={{top: "50%", translate: "0 -50%"}}
                footer={
                    <>
                        <Button
                            onClick={() => {
                                setSearchParams({...searchParams, apartment_number: undefined});
                            }}
                        >
                            {translate("button.cancel")}
                        </Button>
                        {apartment && (
                            <Button
                                onClick={reactToPrintFn}
                                type="primary"
                                ghost
                            >
                                {translate("button.print")}
                            </Button>
                        )}{" "}
                        {/* {user?.role !== "manager" && ( */}
                        <Button
                            type="primary"
                            onClick={() =>
                                setSearchParams({...searchParams, orderModel: "true"})
                            }
                        >
                            {order ? translate("button.edit") : translate("button.sell")}
                        </Button>
                        {/* )} */}
                        {(order?.type === "reserved" || order?.type === "reserved_paid") && (
                            <Button
                                type="primary"
                                style={{backgroundColor: "#52c41a", borderColor: "#52c41a"}}
                                onClick={() =>
                                    setSearchParams({...searchParams, orderModel: "true", addContract: "true"})
                                }
                            >
                                Добавить договор
                            </Button>
                        )}
                    </>
                }
            >
                <div style={{height: "70vh"}}>
                    {isLoading ? (
                        <Loading
                            style={{
                                height: "100%",
                            }}
                        ></Loading>
                    ) : (
                        apartment && (
                            <div className={styles["model-content"]}>
                                <OrderModelSchema
                                    setSearchParams={setSearchParams}
                                    searchParams={searchParams}
                                    refetchInfo={refetchInfo}
                                    refetchApartments={refetchApartments}
                                    order={order}
                                    apartment={apartment}
                                    addContract={searchParams.addContract === "true"}
                                />{" "}
                                <div className={styles.image} style={!order ? {width: '82%'} : {}}>
                                    <div ref={contentRef} style={{width: '100%', height: '100%'}}>
                                        {pdfLoading ? (
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', gap: '16px'}}>
                                                <Spin size="large" />
                                            </div>
                                        ) : pdfUrl ? (
                                            <iframe
                                                src={pdfUrl}
                                                style={{width: '100%', height: '100%', border: 'none'}}
                                                title="PDF Preview"
                                            />
                                        ) : (
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                                <Button
                                                    type="primary"
                                                    size="large"
                                                    onClick={handleGeneratePdf}
                                                >
                                                    PDF генерация / PDF generatsiya / PDF Generation
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.datas} style={!order ? {width: '18%'} : {}}>
                                    <div className={clsx(styles.card)} style={!order? {width:'100%'}:{width:'48%'}}>
                                        <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                            {userData?.id && !order && (
                                                <Button
                                                    type="text"
                                                    loading={favoriteLoading}
                                                    onClick={toggleFavorite}
                                                    icon={isFavorite ? <HeartFilled style={{color: "red", fontSize: 24}}/> : <HeartOutlined style={{fontSize: 24}}/>}
                                                />
                                            )}
                                        </div>
                                        <h2>{translate("apartment.info")}</h2>
                                        <Space>
                                            <b>{translate("apartment.size")}</b>
                                            <p>
                                                {parseFloat(apartment.m2)} {translate("misc.sqm")}
                                            </p>
                                        </Space>
                                        <br/>
                                        <Space>
                                            <b>{translate("apartment.rooms")}</b>
                                            <p>
                                                <b>{apartment?.number}{apartment?.additionalArea ? "+" : ""} </b>
                                            </p>
                                        </Space>
                                        <br/>
                                        <Space>
                                            <b>{translate("apartment.apartment_number")}</b>
                                            <p>{apartment.apartment_number}</p>
                                        </Space>{" "}
                                        <br/>
                                        <Space>
                                            <b>{translate("apartment.floor")}</b>
                                            <p>{apartment.floor}</p>
                                        </Space>{" "}
                                        <br/>
                                        <Space>
                                            <b>{translate("apartment.block")}</b>
                                            <p>{apartment.block}</p>
                                        </Space>{" "}
                                        <br/>
                                        <Space>

                                            <b>{translate("apartment.lodjiya")}</b>
                                            <p>{apartment.loggia} {translate("misc.sqm")}</p>
                                        </Space>{" "}

                                        <br/>{" "}
                                        <Space>
                                            <b>{translate("apartment.status")}</b>
                                            <p>
                                                {{
                                                    sold: translate("status.sold"),
                                                    reserved: translate("status.booked"),
                                                    not_full_paid: translate("status.not_paid"),
                                                    reserved_paid: translate("status.reserved_paid"),
                                                }[order?.type] || translate("status.empty")}
                                            </p>
                                        </Space>
                                        <br/>
                                        <br/>
                                    </div>
                                    {order && (
                                        <>
                                            <PaymentModel
                                                setSearchParams={setSearchParams}
                                                searchParams={searchParams}
                                                refetchInfo={refetchInfo}
                                                order={order}
                                            />
                                            <div className={clsx(styles.card)} style={{width:'48%'}}>
                                                <h2>{translate("sale.info")}</h2>
                                                <Space>
                                                    <b>{translate("sale.customer_name")}</b>
                                                    <p>{order?.client?.customerName}</p>
                                                </Space>{" "}
                                                <br/>
                                                <Space>
                                                    <b>{translate("sale.customer_phone")}</b>
                                                    <p>{order?.client?.customerPhone}</p>
                                                </Space>

                                                {
                                                    order?.type!=="reserved"
                                                    &&
                                                    <><br/>
                                                        {/*<Space>*/}
                                                        {/*  <b>{translate("sale.sold_price_sqm")}</b>*/}
                                                        {/*  <p>*/}
                                                        {/*    {order.costPerSquare}{" "}*/}
                                                        {/*    {{uzs: "UZS", usd: "$"}[order.priceCurrency]}*/}
                                                        {/*  </p>*/}
                                                        {/*</Space>*/}
                                                        <Space>
                                                            <b>{translate("table.column.total_payment")}</b>
                                                            <p>{order?.price?.toString()
                                                                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} </p>
                                                        </Space>{" "}
                                                        <br/>

                                                    </>
                                                }
                                                {/*<br />*/}
                                                {/*<Space>*/}
                                                {/*  <b>*/}
                                                {/*    {translate("sale.monthly_payment", { months: order.paymentDurationPerMonth })}*/}
                                                {/*  </b>*/}
                                                {/*  <p>*/}
                                                {/*    {formatNumberWith(*/}
                                                {/*      Math.round(*/}
                                                {/*        (apartment.m2 **/}
                                                {/*          order.costPerSquare **/}
                                                {/*          (100 - order.downPaymentPercent)) /*/}
                                                {/*          100 /*/}
                                                {/*          order.paymentDurationPerMonth*/}
                                                {/*      )*/}
                                                {/*    )}{" "}*/}
                                                {/*    {translate("misc.currency")}*/}
                                                {/*  </p>*/}
                                                {/*</Space>*/}
                                                <br/> <b>{translate("sale.additional_info")}</b>
                                                <p>{order.description} </p>
                                                <Space>
                                                    <b>{translate("sale.user")}</b>
                                                    <p>
                                                        {order?.user?.username}{" "}

                                                    </p>
                                                </Space>
                                                <br/>
                                                {order?.fileMedia?.url && (
                                                    <>
                                                      <Space>
                                                        <b>{translate("form.label.attached_file")}</b>
                                                        <Button
                                                            type="primary"
                                                            ghost
                                                            icon={<DownloadOutlined />}
                                                            href={`${process.env.REACT_APP_API_URL}/${order.fileMedia.url}`}
                                                            target="_blank"
                                                            download
                                                        >
                                                          {translate("button.download")}
                                                        </Button>
                                                      </Space>
                                                      <br/>
                                                      {order?.file_comment && (
                                                          <>
                                                            <Space>
                                                              <b>{translate("form.label.file_comment")}</b>
                                                              <p>{order.file_comment}</p>
                                                            </Space>
                                                            <br/>
                                                          </>
                                                      )}
                                                    </>
                                                )}
                                                <br/>
                                                {user?.role !== "manager" && (
                                                    (order?.type === "reserved" || order?.type === "reserved_paid") ? (
                                                        <Button
                                                            danger
                                                            type="primary"
                                                            onClick={() => cancelReservation(order)}
                                                        >
                                                            Отменить бронирование
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            danger
                                                            type="primary"
                                                            onClick={() => deleteOrder(order)}
                                                        >
                                                            {translate("sale.delete_order")}
                                                        </Button>
                                                    )
                                                )}
                                                <br/>
                                                {order?.type !== "reserved" && (
                                                    <Space size="middle" style={{marginTop: 10, flexWrap: 'wrap'}}>
                                                        {
                                                            (order?.client?.series || order?.client?.inn)
                                                            &&
                                                            <Button
                                                                type="primary"
                                                                disabled={order?.contracts?.[0]?.my_signature}
                                                                onClick={generateContract}
                                                                loading={contractLoading}
                                                            >
                                                                {translate("button.generate_contract")}
                                                            </Button>
                                                        }
                                                        {!order?.client?.series && !order?.client?.inn && (
                                                            <Button
                                                                type="primary"
                                                                onClick={() => OpenModalIframe(true)}
                                                            >
                                                                {translate("button.verify_user")}
                                                            </Button>
                                                        )}
                                                        {order?.contracts?.[0]?.contract_file && (
                                                            <>
                                                                <Button
                                                                    type="primary"
                                                                    ghost
                                                                    icon={<DownloadOutlined/>}
                                                                    href={`${process.env.REACT_APP_API_URL}/${order.contracts[0].contract_file}`}
                                                                    target="_blank"
                                                                    download
                                                                >
                                                                    {translate("button.contract")}
                                                                </Button>

                                                                {/*<Button*/}
                                                                {/*    disabled={order?.contracts?.[0]?.my_signature}*/}
                                                                {/*    type="primary"*/}
                                                                {/*    onClick={() => OpenModalIframe(false)}*/}
                                                                {/*>*/}
                                                                {/*    {translate("button.sign")}*/}
                                                                {/*</Button>*/}
                                                                <Button
                                                                    type="primary"
                                                                    loading={smsLoading}
                                                                    onClick={() => sendSms({
                                                                        phone: order?.client?.customerPhone,
                                                                        contractNumber: order?.contracts?.[0]?.contractNumber,
                                                                        clientId:order?.client?.id,
                                                                        contractDate:order?.createdAt
                                                                    })}
                                                                >
                                                                    {translate("button.send_sms")}
                                                                </Button>
                                                            </>
                                                        )}
                                                    </Space>
                                                )}
                                                <br/>
                                                <br/>
                                            </div>
                                            <OfflineContractUpload order={order} refetchInfo={refetchInfo} />
                                            <Button
                                                type="default"
                                                onClick={() => setOrderLogOpen(true)}
                                                style={{ marginBottom: 10, width: "100%" }}
                                            >
                                                {translate("orderlog.button")}
                                            </Button>
                                            <OrderLogModal
                                                orderId={order?.id}
                                                open={orderLogOpen}
                                                onClose={() => setOrderLogOpen(false)}
                                            />
                                            <div className={clsx(styles.card, styles.payment)} style={{width:'48%'}}>
                                                <div className={styles.title}>
                                                    <h2>{translate("payment.info")}</h2>
                                                    {user?.role !== "manager" && (
                                                        <Button
                                                            type="primary"
                                                            disabled={order?.type === "sold" && (order?.payments?.reduce((sum, p) => sum + p.amount, 0) >= order?.price)}
                                                            onClick={() =>
                                                                setSearchParams({
                                                                    ...searchParams,
                                                                    paymentModel: "true",
                                                                })
                                                            }
                                                        >
                                                            {translate("payment.add")}
                                                        </Button>
                                                    )}
                                                </div>
                                                <div
                                                    className={clsx(
                                                        styles["card"],

                                                        styles["payment-head"]
                                                    )}
                                                >
                                                    {" "}
                                                    <p>{translate("table.column.amount")}</p>
                                                    <p>{translate("table.column.payment_time")}</p>
                                                    <p>{translate("payment.check")}</p>
                                                    {user?.role !== "manager" &&
                                                        <p>{translate("table.column.delete")}</p>}
                                                </div>
                                                {order.payments?.map((payment) => (
                                                    <div
                                                        className={clsx(
                                                            styles["card"],
                                                            styles["payment-card"]
                                                        )}
                                                    >
                                                        <p>
                                                            {payment.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}{" "}
                                                            {{uzs: "UZS", usd: "$"}[payment.currency]}{" - "}
                                                            {{ cash: translate("payment.cash"), installment: translate("payment.installment"), booking: translate("payment.booking"), click: translate("payment.click"), payme: translate("payment.payme") }[payment.type] || payment.type}
                                                        </p>
                                                        <p>
                                                            {format(payment.date ? new Date(payment.date) : payment.createdAt, "dd-MMMM yyyy", {
                                                                locale: uz,
                                                            })}
                                                        </p>
                                                        <div>
                                                            {payment.checkFile?.url ? (
                                                                <Button>
                                                                    <a download={'true'} target={"_blank"}
                                                                       href={`${process.env.REACT_APP_API_URL}/${payment.checkFile.url}`}>
                                                                        <EyeOutlined/>
                                                                    </a>
                                                                </Button>
                                                            ) : "-"}
                                                        </div>
                                                        {/* {user?.role !== "manager" && ( */}
                                                        <div>
                                                            <Button
                                                                danger
                                                                onClick={() => deletePayment(payment)}
                                                            >
                                                                <MdDelete/>
                                                            </Button>
                                                        </div>
                                                        {/* )} */}
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )
                    )}
                </div>
            </Modal>

            <Modal
                open={iframeModalOpen}
                onCancel={OnCancelIframe}
                footer={null}
                width="90%"
                style={{top: 20}}
                destroyOnClose
            >
                <div style={{height: "80vh"}}>
                    <iframe
                        id="myid_iframe"
                        src={"https://docs.myid.uz/iframe"}
                        allow="camera;fullscreen"
                        allowFullScreen
                        onLoad={handleIframeLoad}
                        style={{width: "100%", height: "100%", border: "none"}}
                    />
                </div>
            </Modal>
        </>
    );
}
